/**
 * PlatformENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PlatformENSiteHeaderLanguages
 */

import { usePlatformENSiteHeaderLanguagesLogic } from '@/hooks/traits/usePlatformENSiteHeaderLanguagesLogic';
import type { PlatformENSiteHeaderLanguagesConfig } from '@/hooks/traits/usePlatformENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PlatformENPlatformView as PlatformENPlatformViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PlatformENSiteHeaderLanguagesViewProps {
  config?: Partial<PlatformENSiteHeaderLanguagesConfig>;
}

export function PlatformENSiteHeaderLanguagesView({ config: propsConfig }: PlatformENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePlatformENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PlatformENPlatformView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PlatformEN" trait="PlatformENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu items={Array.isArray(([{ label: "English" as const, href: "/platform" as const, code: "en" as const }, { href: "/ar/platform" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/platform" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) ? (((([{ label: "English" as const, href: "/platform" as const, code: "en" as const }, { href: "/ar/platform" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/platform" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} className={((([{ label: "English" as const, href: "/platform" as const, code: "en" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/platform" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/platform" as const }]).length === 0)) ? "hidden" : ""} trigger={<Button size="sm" label={String(__locale.toUpperCase())} variant="ghost" icon="globe" />} position="bottom-end" />) : null}
    </TraitScopeProvider>
  );
}

export default PlatformENSiteHeaderLanguagesView;
